.panel {
  width: 360px;
}

.panelHeader {
  padding: 12px 16px 0;
}

.headerDivider {
  margin: 8px 0 0;
}

.listContainer {
  max-height: 420px;
  overflow-y: auto;
}

.skeletonItem {
  padding: 12px 16px;
  border-bottom: 1px solid var(--topbar-border);
}

.notifItem {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  cursor: pointer;
  border: none;
  border-left: 3px solid transparent;
  border-bottom: 1px solid var(--topbar-border);
  background: transparent;
  text-align: left;
  transition: background 0.15s ease;
}

.notifItem:last-child {
  border-bottom: none;
}

.notifItem:hover {
  background: #f5f8fb;
}

.notifItemUnread {
  background: rgba(0, 191, 165, 0.04);
  border-left-color: var(--sidebar-accent);
}

.notifItemUnread:hover {
  background: rgba(0, 191, 165, 0.08);
}

.iconCircle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 1px;
}

.notifBody {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.notifItem .notifMessage {
  display: block;
  font-size: 13px;
  line-height: 1.45;
}

.notifItem .notifTime {
  font-size: 11px;
}

.unreadDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--sidebar-accent);
  flex-shrink: 0;
  margin-top: 5px;
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
}

.emptyIcon {
  font-size: 24px;
  color: #aab8c8;
}

.bellButton:global(.ant-btn) {
  color: #4a6478;
}

.bellButton:global(.ant-btn):hover {
  color: var(--sidebar-accent);
  background: rgba(0, 191, 165, 0.08);
}

.popoverOverlay :global(.ant-popover-inner) {
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(13, 27, 42, 0.12);
}
